import { Badge, Box, Typography } from '@veraclins-dev/ui';

import { workCards } from '../../content/case-studies';
import { AppLink } from '../../link';

const cardClassName =
  'block rounded-3xl border border-primary/12 bg-card p-5 pb-[18px] sm:p-[30px] sm:pb-[26px] no-underline shadow-[0_12px_32px_-22px_rgba(40,20,10,.5)] transition hover:-translate-y-0.5';

const chipClassName =
  'rounded-lg border border-primary/14 bg-[color-mix(in_oklch,var(--primary)_10%,var(--card))] px-2.5 py-1 text-xs font-semibold text-foreground';

export function WorkIndex() {
  return (
    <Box display="flex" flexDirection="column">
      <Box
        component="section"
        display="flex"
        flexDirection="column"
        items="start"
        pt={16}
        pb={10}
      >
        <Typography
          component="p"
          mb={4}
          className="text-xs font-bold uppercase tracking-widest text-primary"
        >
          Selected work
        </Typography>
        <Typography
          variant="h1"
          mb={4}
          className="font-sans text-5xl font-extrabold leading-tight tracking-tight"
        >
          Things I've designed, built and shipped.
        </Typography>
        <Typography
          component="p"
          // oxlint-disable-next-line veraclins-ui/prefer-style-props -- 64ch max-width has no maxW scale-token/prop equivalent
          className="max-w-[64ch] text-lg leading-relaxed text-foreground/70"
        >
          A mix of enterprise engagements and products I build myself. Click any
          project for the full story — the problem, what I did, and how it
          turned out.
        </Typography>
      </Box>

      <Box
        component="section"
        display="grid"
        gridCols={{ xs: 1, md: 2 }}
        pb={10}
        // oxlint-disable-next-line veraclins-ui/prefer-style-props -- 22px grid gap has no scale-token/prop equivalent
        className="gap-5.5"
      >
        {workCards.map((card) => {
          const cardBody = (
            <>
              <Box display="flex" items="center" justify="between" gap={3}>
                <Badge
                  variant="soft"
                  tone="brand"
                  pill
                  className="text-xs/normal font-bold uppercase tracking-wider"
                >
                  {card.kind}
                </Badge>
                <Typography
                  component="span"
                  variant="inherit"
                  className="text-xs/normal text-foreground/50"
                >
                  {card.period}
                </Typography>
              </Box>
              <Typography
                variant="h2"
                mb={2}
                mt={4}
                className="font-sans text-2xl font-extrabold tracking-tight"
              >
                {card.name}
              </Typography>
              <Typography
                component="p"
                mb={4}
                className="text-base leading-relaxed text-foreground/70"
              >
                {card.tagline}
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={2}>
                {card.chips.map((chip) => (
                  <Typography
                    key={chip}
                    component="span"
                    variant="inherit"
                    className={chipClassName}
                  >
                    {chip}
                  </Typography>
                ))}
              </Box>
            </>
          );

          if (card.href) {
            return (
              <AppLink
                key={card.name}
                to={card.href}
                tone="neutral"
                className={cardClassName}
              >
                {cardBody}
              </AppLink>
            );
          }

          return (
            <Box key={card.name} className={cardClassName}>
              {cardBody}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
